import { CompetencyMapQuery } from "@generated/graphql";
import { CompetencyMapSelectedParts } from "helpers/competencyMapSelectParts";
import { TestingSelectModalContext } from "context/testingSelectModalContext";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { getCompetencyMapError } from "helpers/competencyMapValidation";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

interface CreateTestingProps {
  competencyMap: CompetencyMapQuery["competencyMap"];
}

const useCreateTesting = ({ competencyMap }: CreateTestingProps) => {
  const navigate = useNavigate();
  const { addToast } = useContext(ToastContext);
  const { handleOpen } = useContext(TestingSelectModalContext);

  const createTesting = (selectParts?: CompetencyMapSelectedParts) => {
    const error = getCompetencyMapError(competencyMap, selectParts);

    if (error) {
      addToast({
        type: ToastTypeEnum.ERROR,
        text: error,
      });
    } else {
      handleOpen({ navigate, mapId: competencyMap?.id, selectParts });
    }
  };

  return { createTesting };
};

export default useCreateTesting;
